import { useWatch } from '@jucy-ui/forms';
import { SearchFormValues } from '../types/SearchFormValues';

export const useSearchFormFieldValues = useWatch<SearchFormValues>;
